import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

interface OutageMarkerIconProps extends Omit<SvgIconProps, 'color'> {
  variant?: 'round' | 'square';
  text: string | number;
  title?: string;
  strokeColor?: string;
  textColor?: string;
  fillColor?: string;
  size?: number;
}

const OutageMarkerIcon: React.FC<OutageMarkerIconProps> = ({
  variant = 'round',
  text,
  title,
  strokeColor = '#D63F2F',
  textColor = 'white',
  fillColor = '#D63F2F',
  size = 32,
  ...props
}) => {
  const rx = variant === 'round' ? 19 : 4;
  const shadow = `drop-shadow(0px 0px ${size * 0.15}px rgba(0,0,0,0.5))`;
  const dynamicFontSize =
    text.toString().length > 3 ? size * 0.29 : size * 0.38;

  return (
    <SvgIcon
      {...props}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
      style={{ filter: shadow }}
    >
      <g>
        {title && <title>{title}</title>}
        <rect x={0} y={0} width={size} height={size} rx={rx} fill={fillColor} />
        <rect
          x={1}
          y={1}
          width={size - 2}
          height={size - 2}
          rx={rx - 1}
          strokeWidth={2}
          stroke={strokeColor}
          fill="none"
        />
        <text
          fontFamily="var(--font-untitledSans)"
          fontWeight="bold"
          fontSize={dynamicFontSize}
          textAnchor="middle"
          alignmentBaseline="central"
          x="50%"
          y="50%"
          //className={textColor}
          color={textColor}
        >
          {text}
        </text>
      </g>
    </SvgIcon>
  );
};

export default OutageMarkerIcon;

{
  /* <SvgIcon
  {...props}
  viewBox={`0 0 ${size} ${size}`}
  xmlns="http://www.w3.org/2000/svg"
  style={{ fill: 'none' }}
>
  <g>
    {title && <title>{title}</title>}
    <rect
      x="1"
      y="1"
      width={size - 2}
      height={size - 2}
      rx={rx}
      stroke={strokeColor}
      strokeWidth="2"
      fill={fillColor}
    />
    <text
      fill={textColor}
      fontFamily="Untitled Sans, sans-serif"
      fontSize={14}
      fontWeight="bold"
      textAnchor="middle"
      dominantBaseline="central"
      x={size / 2}
      y={size / 2}
    >
      {text}
    </text>
  </g>
</SvgIcon> */
}

/* import React from "react";
import clsx from "clsx";

type OutageMarkerIconProps = {
  size?: number;
  text: string;
  title?: string;
  withShadow?: boolean;
  square?: boolean;
  variant?: "default" | "hover" | "hoverEffect";
  className?: string;
};

const OutageMarkerIcon: React.FC<OutageMarkerIconProps> = ({
  size = 44,
  text,
  title = "",
  withShadow = false,
  square = false,
  variant = "default",
  className = "",
}) => {
  const shadow = `drop-shadow(0px 0px ${size * 0.15}px rgba(0,0,0,0.5))`;
  const rx = square ? size * 0.1 : size / 2;

  // Define base + hover colors
  const isHover = variant === "hover";
  const isHoverEffect = variant === "hoverEffect";

  const bgClass = clsx(
    "transition-colors",
    isHover ? "fill-white" : "fill-error",
    isHoverEffect && "group-hover:fill-white",
  );

  const strokeClass = clsx(
    "transition-colors",
    isHover ? "stroke-error" : "stroke-white",
    isHoverEffect && "group-hover:stroke-error",
  );

  const textClass = clsx(
    "transition-colors",
    isHover ? "fill-error" : "fill-white",
    isHoverEffect && "group-hover:fill-error",
  );

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
      className={`${clsx(isHoverEffect && "group")} ${className}`}
      style={{ filter: withShadow ? shadow : "none" }}
    >
      <g>
        {title && <title>{title}</title>}
        <rect
          x={0}
          y={0}
          width={size}
          height={size}
          rx={rx}
          className={bgClass}
        />
        <rect
          x={1}
          y={1}
          width={size - 2}
          height={size - 2}
          rx={rx - 1}
          strokeWidth={2}
          className={strokeClass}
          fill="none"
        />
        <text
          fontFamily="var(--font-untitledSans)"
          fontWeight="bold"
          fontSize={size * 0.35}
          textAnchor="middle"
          alignmentBaseline="middle"
          x="50%"
          y="50%"
          className={textClass}
        >
          {text}
        </text>
      </g>
    </svg>
  );
};

export default OutageMarkerIcon;
 */
